"use strict";

import 'unfetch/polyfill';

export default class RestController {

    constructor(rest_url, partner)
    {
        this.base_url = `${rest_url}partners/v1/${partner}`;
        this.brands_url =  '/brands';
        this.models_url =  '/generations';
        this.built_dates_url =  '/years';
        this.submodels_url =  '/submodels';
        this.types_url = '/types';
        this.constructions_url = '/constructions';
        this.prices_url = '/prices';
    }

    async brands()
    {
        let url = `${this.base_url}${this.brands_url}/`;
        return this.get(url);
    }

    async models(brand, month = null, year = null)
    {
        let url = `${this.base_url}${this.models_url}/${brand}/?month=${month}&year=${year}`;
        return this.get(url);
    }

    async built_dates(brand, model)
    {
        let url = `${this.base_url}${this.built_dates_url}/${brand}/${model}/`;
        return this.get(url);
    }

    async constructions(brand, model, built_date)
    {
        let url = `${this.base_url}${this.constructions_url}/${brand}/${model}/${built_date}/`;
        return this.get(url);
    }

    async submodels(brand, model, built_date, construction)
    {
        let url = `${this.base_url}${this.submodels_url}/${brand}/${model}/${built_date}/${construction}/`;
        return this.get(url);
    }

    async types(brand, model, built_date, construction, submodel)
    {
        let url = `${this.base_url}${this.types_url}/${brand}/${model}/${built_date}/${construction}/${submodel}/`;
        return this.get(url);
    }

    async prices(service, brand, generation, type, postalcode)
    {
        let url = `${this.base_url}${this.prices_url}/${service}/${brand}/${generation}/${type}/${postalcode}/`;
        return this.get(url);
    }

    async get(url)
    {
        return fetch(url)
            .then((response) => {
                return response.json();
            })
            .then((json) => {
                return json;
            });
    }
};